export default __webpack_public_path__ + "locales/zh-CN/DeleteThirdPartyDialog.json?hash=cf120b7ddaf3a78ce3c0c99efa05fb9a";